/* eslint-disable import/prefer-default-export */
import PropTypes from 'prop-types';

const CommissionRuleType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  threshold: PropTypes.number.isRequired,
  minValue: PropTypes.number.isRequired,
  maxValue: PropTypes.number.isRequired,
  initialPercentage: PropTypes.number.isRequired,
});

export { CommissionRuleType };
